import { render, staticRenderFns } from "./ConferenceSessionDetail.vue?vue&type=template&id=37edee1a&scoped=true"
import script from "./ConferenceSessionDetail.vue?vue&type=script&lang=js"
export * from "./ConferenceSessionDetail.vue?vue&type=script&lang=js"
import style0 from "./ConferenceSessionDetail.vue?vue&type=style&index=0&id=37edee1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37edee1a",
  null
  
)

export default component.exports